import { render, staticRenderFns } from "./SubAssignmentsView.vue?vue&type=template&id=540798c4&scoped=true&"
import script from "./SubAssignmentsView.vue?vue&type=script&lang=js&"
export * from "./SubAssignmentsView.vue?vue&type=script&lang=js&"
import style0 from "./SubAssignmentsView.vue?vue&type=style&index=0&id=540798c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540798c4",
  null
  
)

export default component.exports